import Vue from "vue";

export default {
  methods: {
    updateQueryStrings(query = null) {
      // Atualiza as query strings da url
      this.$router.replace({
        query: query || { ...this.filters, ...this.pagination }
      });
    },
    boot() {
      if (this.getItems) {
        this.filters = {
          ...this.filters,
          ...this.pagination,
          ...this.$route.query
        };
        this.getItems();
      }
    }
  }
};
